import { numberFormat } from '@/helper/numberFormatter';

let measureCanvas: HTMLCanvasElement | null = null;

// Utility to measure text width using canvas
export const measureTextWidth = (text: string, font: string): number => {
  if (!measureCanvas) {
    measureCanvas = document.createElement('canvas');
  }
  const context = measureCanvas.getContext('2d');
  if (!context) return 0;
  context.font = font;
  return context.measureText(text).width;
};

// Helper to split label and append value if needed, for originating/terminating nodes
export const getWords = (
  name: string,
  value: number | undefined,
  nodeHeight: number,
  showValue = false,
  canHideLabel = false,
  canBreakWords = true,
) => {
  const lineHeight = 14;
  const valueHeight = 18;
  const padding = 2;
  let words = canBreakWords ? name.split(' ') : [name];
  let labelHeight = words.length * lineHeight;
  let valueShown = false;
  if (showValue) {
    if (labelHeight + valueHeight + padding <= nodeHeight) {
      valueShown = true;
      // Add colon to last word if value will be shown
      if (words.length > 0) {
        words = [...words];
        words[words.length - 1] = words[words.length - 1] + ':';
      }
      words = [...words, value !== undefined ? numberFormat(value) : ''];
      labelHeight = words.length * lineHeight;
    } else if (canHideLabel && labelHeight > nodeHeight) {
      return { words: [], showValue: false, labelHeight: 0 };
    }
  } else {
    if (labelHeight > nodeHeight) return { words: [], showValue: false, labelHeight: 0 };
  }
  return { words, valueShown, labelHeight };
};
